import { useEffect } from "react";

export const useClickOutside = (ref, handler, ignoreNodeId) => {
  useEffect(() => {
    const eventListener = (event) => {
      if (
        !ref.current ||
        ref.current.contains(event.target) ||
        (ignoreNodeId && event.target.closest(`#${ignoreNodeId}`))
      ) {
        return;
      }
      handler(event);
    };

    document.addEventListener("mousedown", eventListener);
    return () => {
      document.removeEventListener("mousedown", eventListener);
    };
  }, [ref, handler]);
};
